/**
 * Generated runtime TestId mirror for frontend/src/pages/EnforcementObjectDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const EnforcementObjectDetailTestIds = {
  cardEnforcementObjectDetails: "card-enforcement-object-details",
  cardTitleAccessProfiles: "card-title-access-profiles",
  cardTitleRelatedEntities: "card-title-related-entities",
  colName: "col-name",
  colResource: "col-resource",
  colRiskLevel: "col-risk-level",
  colStatus: "col-status",
  enforcementObjectDetailPage: "enforcement-object-detail-page",
  linkResourceDetail: "link-resource-detail",
  linkSystemDetail: "link-system-detail",
  sectionAttributes: "section-attributes",
  linkProfile: (profile_id: string) => `link-profile-${profile_id}`,
  linkProfilePrefix: () => "link-profile-" as TestIdPrefix,
  linkResource: (profile_resource_id: string) => `link-resource-${profile_resource_id}`,
  linkResourcePrefix: () => "link-resource-" as TestIdPrefix
} as const;
